import { datalabHttp } from '@dbl/services/common';

// 点赞点踩
export const updateLike = (params: any) =>
	datalabHttp({
		url: '/api/v1/alg/chatbi/update_like',
		method: 'post',
		data: params
	});

// 首页问题数据
export const getChatHomeData = (params: any) =>
	datalabHttp({
		url: '/api/v1/alg/chatbi/homepage',
		method: 'post',
		data: params
	});
